import { useEffect, useRef, useState } from 'react';
import { Link } from 'react-router-dom';
import { useFavorites } from '@/hooks/useFavorites';
import { articles } from '@/mocks/articles';

interface FavoritesMenuProps {
  solid: boolean;
}

export default function FavoritesMenu({ solid }: FavoritesMenuProps) {
  const { ids } = useFavorites();
  const [open, setOpen] = useState(false);
  const ref = useRef<HTMLDivElement>(null);

  useEffect(() => {
    const onClick = (e: MouseEvent) => {
      if (ref.current && !ref.current.contains(e.target as Node)) setOpen(false);
    };
    document.addEventListener('mousedown', onClick);
    return () => document.removeEventListener('mousedown', onClick);
  }, []);

  const favArticles = articles.filter((item) => ids.includes(item.id));

  return (
    <div className="relative" ref={ref}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-label="我的收藏"
        className={`relative w-9 h-9 flex items-center justify-center rounded-md transition-colors cursor-pointer ${
          solid
            ? 'text-foreground-700 hover:text-primary-500 hover:bg-primary-50'
            : 'text-background-50 hover:text-primary-200'
        }`}
      >
        <i className="ri-bookmark-line text-xl" />
        {ids.length > 0 && (
          <span className="absolute -top-0.5 -right-0.5 min-w-[16px] h-4 px-1 rounded-full bg-accent-500 text-background-50 text-[10px] leading-4 font-bold text-center">
            {ids.length}
          </span>
        )}
      </button>

      {open && (
        <div className="absolute right-0 mt-2 w-72 rounded-lg border border-background-200 bg-background-50 p-2 animate-slide-down">
          <p className="px-2 py-1.5 text-xs font-semibold text-foreground-500">
            我的收藏 · 仅本设备
          </p>
          {favArticles.length === 0 ? (
            <p className="px-2 py-4 text-sm text-foreground-500 text-center">
              还没有收藏内容，去详情页点一下书签吧
            </p>
          ) : (
            <ul className="max-h-72 overflow-y-auto">
              {favArticles.map((item) => (
                <li key={item.id}>
                  <Link
                    to={`/detail/${item.id}`}
                    onClick={() => setOpen(false)}
                    className="block px-2 py-2 rounded-md hover:bg-background-100 cursor-pointer"
                  >
                    <span className="block text-sm font-medium text-foreground-900 line-clamp-2">
                      {item.title}
                    </span>
                    <span className="block mt-0.5 text-xs text-foreground-500">
                      {item.tags.slice(0, 2).join(' · ')}
                    </span>
                  </Link>
                </li>
              ))}
            </ul>
          )}
        </div>
      )}
    </div>
  );
}